import MuiIconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
// @TODO Update: Material UI migration hotspot - vai virar hook
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

import { createSetObject } from "../core/util";
import { colors as themeColors } from "../theme";

const styles = {
  primary: { color: themeColors.primary },
  secondary: { color: themeColors.secondary },
  success: { color: themeColors.success },
  warning: { color: themeColors.warning },
  danger: { color: themeColors.danger },
  dangerDark: { color: themeColors.dangerDark },
};
// @TODO Update: estudar como remover referências diretas

const customColors = createSetObject(
  "primary",
  "secondary",
  "success",
  "warning",
  "danger",
  "dangerDark",
);

function getLinkProps(link, href) {
  if (link) {
    return { component: Link, to: link };
  }
  if (href) {
    return { component: "a", href };
  }
  return null;
}

// MUI v9 + Tooltip/Modal/Transition exigem que o filho aceite `ref`.
// Como esse IconButton é usado como filho de <Tooltip> em vários lugares
// (e como child de Transition em outros), precisa de `forwardRef` —
// senão dá "Function components cannot be given refs" + warning de prop type.
const IconButton = React.forwardRef(function IconButton(props, ref) {
  const { color = "default", tooltip, disabled, link, href, children, ...other } = props;
  const linkProps = getLinkProps(link, href);
  const isCustomColor = customColors[color];

  const rootComponent = (
    <MuiIconButton
      ref={ref}
      color={isCustomColor ? "primary" : color}
      classes={isCustomColor ? { colorPrimary: styles[color] } : null}
      {...linkProps}
      {...other}
      disabled={disabled}
    >
      {children}
    </MuiIconButton>
  );

  if (disabled || !tooltip) {
    return rootComponent;
  }
  return <Tooltip title={tooltip}>{rootComponent}</Tooltip>;
});

IconButton.defaultProps = {
  color: "default",
  disabled: false,
  link: null,
  href: null,
  disableRipple: false,
  tooltip: null,
};

IconButton.propTypes = {
  /**
   * A cor do plano de fundo do botão.
   */
  color: PropTypes.oneOf([
    "inherit",
    "default",
    "primary",
    "secondary",
    "warning",
    "success",
    "danger",
    "dangerDark",
  ]),
  /**
   * Uma URL para uma `View`.
   */
  // string ou (tuple) => string — resolvido em runtime nas tabelas.
  link: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /**
   * Uma URL para uma página externa.
   */
  // string ou (tuple) => string — resolvido em runtime nas tabelas.
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /**
   * O `title` da [Tooltip](https://material-ui.com/demos/tooltips/).
   */
  tooltip: PropTypes.string,
  /**
   * Pode ser bool literal ou função `(tuple) => bool` (resolvida em runtime
   * pelas tabelas/menus quando a ação depende da linha). Antes era só `bool`,
   * mas espalhar `...IconButton.propTypes` em `Table`/`ActionMenu` sobrescrevia
   * o `oneOfType` declarado lá, gerando warnings.
   */
  disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  /**
   * [disableRipple](https://material-ui.com/api/icon-button/).
   */
  disableRipple: PropTypes.bool,
};

// @TODO Update: Material UI migration hotspot - vai virar hook
export default IconButton;
